function initLabel(form) {
	const groups = $(form).find(".form__group--js")

	if (groups.length) {
		var $inputs = $("input", groups);
		var $textareas = $("textarea", groups);

		var fn = function () {
			if ($(this).val().trim() !== "") {
				$(this).closest(".form__group").addClass("form__group--filled");
			}

			$(this).on("focus", function () {
				$(this).closest(".form__group").addClass("form__group--filled");
			});

			$(this).on("blur", function () {
				if ($(this).val().trim() === "")
					$(this).closest(".form__group").removeClass("form__group--filled");
			});
		};

		$inputs.each(fn);

		$textareas.each(fn);
	}
}

initLabel($(".js-form"))
